export default __webpack_public_path__ + "static/media/2.73c5f61f.webp";